export default __webpack_public_path__ + "static/media/HEDLogo.1cb04919.svg";